import { recordEvent } from "app/analytics";
import { AnalyticsEventType } from "app/types";

export enum RegisterMethod {
  EMAIL = "email",
  GOOGLE = "google",
  APPLE = "apple",
  QR = "qr",
}

// 保護者登録のダイアログを開いたところ。ダイアログの外（最初の登録の画面）は auth_page
let registerSource: string | null = null;
// REGISTER_COMPLETE を送った uid（登録の処理が複数の画面で動いても 1 回だけ送る）
const completedUids = new Set<string>();

export const setRegisterSource = (source: string | null) => {
  registerSource = source;
};

const currentSource = () => registerSource ?? "auth_page";

export const methodOfProvider = (providerId: string): RegisterMethod | null => {
  switch (providerId) {
    case "password":
      return RegisterMethod.EMAIL;
    case "google.com":
      return RegisterMethod.GOOGLE;
    case "apple.com":
      return RegisterMethod.APPLE;
    default:
      return null;
  }
};

/** Firebase のエラーは code、それ以外（ネイティブの結果の文字列など）は sign_in_failed */
export const registerErrorCode = (error: unknown): string => {
  const code = (error as { code?: unknown })?.code;
  return typeof code === "string" ? code : "sign_in_failed";
};

export const recordRegisterPromptShow = (source: string) => {
  recordEvent(AnalyticsEventType.REGISTER_PROMPT_SHOW, { source });
};

export const recordRegisterPromptClose = (source: string) => {
  recordEvent(AnalyticsEventType.REGISTER_PROMPT_CLOSE, { source });
};

export const recordRegisterStart = (method: RegisterMethod) => {
  recordEvent(AnalyticsEventType.REGISTER_START, { source: currentSource(), method });
};

export const recordRegisterError = (method: RegisterMethod | null, errorCode: string) => {
  recordEvent(AnalyticsEventType.REGISTER_ERROR, {
    source: currentSource(),
    method: method ?? "unknown",
    error_code: errorCode,
  });
};

export const recordRegisterComplete = (
  uid: string,
  providerId: string,
  claimStatus: string | undefined,
) => {
  if (completedUids.has(uid)) return;
  completedUids.add(uid);
  recordEvent(AnalyticsEventType.REGISTER_COMPLETE, {
    source: currentSource(),
    method: methodOfProvider(providerId) ?? "unknown",
    claim_status: claimStatus ?? "unknown",
  });
};
